import EditOutlined from '@mui/icons-material/EditOutlined';
import { buttonBaseClasses, buttonClasses } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import { t } from 'i18next';

import { SmallButton } from '~components/Order/ordersDispatchStyledComponents';
import { NEW_DISPATCH_TOPBAR_CONTROLS_HEIGHT_IN_PX } from '~constants/filters';

interface EditProjectCTAProps {
  onClick: () => void;
}

export default function EditProjectCTA({ onClick }: EditProjectCTAProps) {
  return (
    <Tooltip title={t('project.edit_project')}>
      <span>
        <SmallButton
          color="brandV2Orange"
          variant="text"
          startIcon={<EditOutlined />}
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            onClick();
          }}
          sx={(theme) => ({
            [`&.${buttonBaseClasses.root}`]: {
              border: 'solid 1px transparent',
              borderRadius: '50%',
              height: NEW_DISPATCH_TOPBAR_CONTROLS_HEIGHT_IN_PX,
              minWidth: NEW_DISPATCH_TOPBAR_CONTROLS_HEIGHT_IN_PX,
              p: 0,
              width: NEW_DISPATCH_TOPBAR_CONTROLS_HEIGHT_IN_PX,
              '&:hover': { borderColor: theme.brandV2.colors.treadOrange },
              [`.${buttonClasses.startIcon}`]: { mx: 0 },
            },
          })}
        />
      </span>
    </Tooltip>
  );
}
